import * as types from "./types";
import {
    postAdminAxios,
    getUserListAxios,
    getOrderListAxios,
    postCompleteOrderAxios,
} from "./services";


  export async function postAdminAction({ commit }, payload) {
    commit(types.LOADING_ECOMMERCE, true);
    try {
      await postAdminAxios(payload);
      commit(types.POST_ADMIN, payload);
    } catch (e) {
      throw e;
    } finally {
      commit(types.LOADING_ECOMMERCE, false);
    }
  }

  export async function getUserListAction({commit}) {
      commit(types.LOADING_ECOMMERCE, true);
      try {
          const {data} = await getUserListAxios();
          commit(types.GET_USER, data.result);
          return data.result;
      }
      catch(e) {
          throw e;
      }
      finally {
          commit(types.LOADING_ECOMMERCE, false);
      }
  }

  export async function getOrderListAction({commit}) {
    commit(types.LOADING_ECOMMERCE, true);
    try {
        const {data} = await getOrderListAxios();
        commit(types.GET_ORDER, data.result);
        return data.result;
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ECOMMERCE, false);
    }
}

export async function postCompleteOrderAction({ commit },{ orderId, status }) {
  commit(types.LOADING_ECOMMERCE, true);
  try {
    await postCompleteOrderAxios(orderId, status);
    commit(types.POST_COMPLETE_ORDER, orderId, status);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_ECOMMERCE, false);
  }
}